/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { useEffect } from "react";
import {
	ButtonLayout,
	ButtonPrimary,
	Grid,
	IconWarningLight,
	Text3,
	skinVars,
	useScreenSize,
} from "@telefonica/mistica";

import { observer } from "mobx-react-lite";
import { useAnalytics, useNavigateCustom } from "../../../../hooks";
import { strings } from "../../../../localization";
import { ScreenResponsive } from "../../../../components/organisms";
import { FeedbackContainer } from "../../../../components";
import { useGlobalStore } from "../../../../contexts/globalStoreContext";

const { button, description, title } = strings.pages.errorUnderageCustomer;

const ErrorUnderageCustomer: React.FC = observer(() => {
	const navigation = useNavigateCustom();
	const { isDesktopOrBigger } = useScreenSize();
	const { addAnalyticEvent, updatePageView } = useAnalytics();
	const { authenticationStore } = useGlobalStore();

	useEffect(() => {
		updatePageView({ name: "Vivo Pay FGTS Cliente menor de idade", pagePath: "/fgts/underage_customer" });
	}, []);

	// Função que redireciona o usuário para a tela de reenvio de documento
	const handleSignOut = () => {
		navigation("/", { replace: true });
		addAnalyticEvent({ action: "click.button", step: "fgts:underage-costumer", description: button }, { applySanitize: true });
	};

	const handlePopState = (): void => {
		navigation("/", { replace: true });
	};

	useEffect(() => {
		authenticationStore.logout();
		// Adiciona um listener ao evento popstate
		window.addEventListener("popstate", handlePopState);

		// Limpa o listener ao desmontar o componente
		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, [navigation]);

	return (
		<ScreenResponsive>
			<Grid justifyContent="center">
				<FeedbackContainer
					icon={<IconWarningLight size={64} color={skinVars.colors.brand} />}
					title={title}
					description={description}
				>
					<ButtonLayout align={isDesktopOrBigger ? "left" : "center"}>
						<ButtonPrimary onPress={handleSignOut} style={{ width: isDesktopOrBigger ? "auto" : "100%" }}>
							<Text3 medium color={skinVars.colors.textButtonPrimary}>
								{button}
							</Text3>
						</ButtonPrimary>
					</ButtonLayout>
				</FeedbackContainer>
			</Grid>
		</ScreenResponsive>
	);
});

export default ErrorUnderageCustomer;
